import React from 'react';
import Attribute from './attribute';
import SlideIn from '../../animations/SlideIn';
import cn from 'classnames';
import { domIdFor } from '../util';

function Composer({ attributes, editing, sectionTitle, highlightId }){
  const stylePrefix = (suffix) => `editor__attribute__${suffix}`;

  return (
    <div className="editor__attribute-set">
      {
        attributes.map((attribute) => {
          const hasDeps = Boolean(attribute.dependents);
          const hasMultiple = hasDeps && attribute.dependents.length > 1;
          const domId = domIdFor(sectionTitle, attribute.id);
          const state = String(attribute.value ?? null);
        
          return (
            <div
              data-cy="attribute"
              id={domId}
              key={attribute.id}
              className={cn(
                stylePrefix(attribute.component),
                {
                  editor__attribute: true,
                  [stylePrefix('pair')]: hasDeps && !hasMultiple,
                  [stylePrefix('multiple')]: hasDeps && hasMultiple,
                  [stylePrefix('found')]: Boolean(highlightId) && highlightId === domId,
                  [`editor__attribute--${state}`]: attribute.component === 'Boolean'
                }
              )}
            >
              <Attribute editing={editing} {...attribute} />

              {hasDeps && (
                <div
                  data-cy="attribute-dependents"
                  className={cn({
                    [stylePrefix('dependents')] : true,
                    [stylePrefix('dependents-disabled')] : !attribute.value
                  })}
                >
                    {
                      attribute.dependents.map((attr) => {
                        return (<Attribute
                          key={attr.id + '-dep'}
                          {...attr}
                          hideLabel={true}
                          active={!!attribute.value}
                          editing={editing}
                        />)
                      })
                    }
                </div>
              )}
            </div>
          );
        })
      }
    </div>
  );

}

export default Composer;
